/* eslint-disable react-hooks/exhaustive-deps */
import React  from "react";
import Form from "../../../shared/forms/Form";
import Field from "../../../shared/forms/Field";
import FormDropDown from "../../../shared/forms/FormFields/FormDropDown";
import FormCalendar from "../../../shared/forms/FormFields/FormCalendar";
import PrioridadTemplate from "../PrioridadTemplate";
import FormTextArea from "../../../shared/forms/FormFields/FormTextArea";
import { default as constantesCatalogos } from "../../../catalogos/constantes";
import useSeguridad from "../../../Seguridad/useSeguridad";
const GeneralSolicitudVacantes = ({value, onChange, onValidate, puedeEditar,errors,submitted, mostrarOperador}) => { 
    const seguridad = useSeguridad();  
    let permisoOperativa= seguridad.tieneAcceso(constantesCatalogos.opciones.permisoSolicitudOperativa);
    let permisoAdm = seguridad.tieneAcceso(constantesCatalogos.opciones.permisoSolicitudAdm);

    return (
        <>              
               <Form columns={4} values={value} onChange={onChange} onValidate={onValidate}
                  formDisabled={!puedeEditar}>

                <Field label={'Fecha Solicitud'} field={'fechaSolicitud'} render={FormCalendar} required={true} disabled={true}
                       cols={2}/>
                {permisoAdm &&
                <Field label={"Motivo Solicitud"} field={"motivoSolicitudId"} source={"motivoSolicitud"} render={FormDropDown}
                       required={true} cols={2}/>
                }
                <Field label={"Nivel Prioridad"} field={"prioridadId"} source="general/PrioridadIncidencia"
                       render={FormDropDown}
                       itemTemplate={PrioridadTemplate}
                       required={true} cols={2}/> 
              { permisoOperativa && mostrarOperador && (
                    <Field
                        field={'empleadoId'}
                        label={'Operador'}
                        cols={2}
                        errors={errors.empleadoId}
                        className={submitted && errors?.empleadoId ? "p-invalid" : ""}
                        render={({ onParentChange, parent, ...props }) => (
                            <FormDropDown
                                {...props}
                                source="empleados"
                                params={{
                                    todasLasEmpresas: true
                                }}
                            />
                        )}
                    />
                )}

                <Field field={'empresaId'} label={'Empresa'} cols={2}
                       render={({onParentChange, parent, ...props}) => <FormDropDown {...props} required={true}
                                                                                     source="todasEmpresas"
                                                                                      valueById={true}
                                                                                   
                                                                                    />
                       }
                />
                {permisoAdm &&
                    <Field field={'departamentoId'} label={'Departamento'} cols={2}
                        render={({onParentChange, parent, ...props}) => <FormDropDown {...props}
                                                                                        source="departamentos"
                                                                                        valueById={true}
                                                                                    
                                                                                        />
                        }
                    />
                 }
                   <Field field={'unidadNegocioId'} label={'Unidad de Negocio'} cols={2}
                       render={({onParentChange, parent, ...props}) => <FormDropDown {...props} required={true}
                                                                                     source="unidadesNegocio"
                                                                                      valueById={true}
                                                                                   
                                                                                    />
                       }
                />      
                {permisoAdm &&
                    <Field field={'puestoId'} label={'Puesto'} cols={2}
                        render={({onParentChange, parent, ...props}) => <FormDropDown {...props} 
                                                                                        source="puestos"
                                                                                        valueById={true}
                                                                                    
                                                                                        />
                        }
                    />
                 }
                {permisoOperativa &&
                <Field field={'tipoOperadorId'} label={'Tipo Operador'} cols={2}
                        render={({onParentChange, parent, ...props}) => <FormDropDown {...props} 
                                                                                        source="tiposEmpleado"
                                                                                        valueById={true}                                                                                        
                                                                                         className={submitted && errors?.tipoOperadorId ? "p-invalid" : ""}
                                                                                        error={errors?.tipoOperadorId}
                                                                                        />
                        }
                    />      
                 }
                 {permisoOperativa &&
                  <Field
                    field="unidadId"
                    label="Unidad"
                    cols={2}
                    errors={errors?.unidadId}
                    className={submitted && errors?.unidadId ? "p-invalid" : ""}
                    render={(props) => (
                        <FormDropDown
                        {...props}
                        source="unidades"
                        params={{ todasLasEmpresas: true }}
                        valueById
                        errors={errors?.unidadId}
                        className={submitted && errors?.unidadId ? "p-invalid" : ""}
                        />
                    )}
                    />

                 }
                {permisoOperativa &&
                <Field label={"Motivo Solicitud"} field={"motivoSolicitudOperativa"} source={"motivoSolicitudOperativas"} render={FormDropDown}
                       required={true} cols={2}/>
                }
                 <Field label="Descripción del puesto" field="descripcionPuesto" required={true} 
                    render={FormTextArea} cols={4} rows={3} maxLength={800}
                />
                 <Field label="Comentarios" field="comentarios" required={true}
                    render={FormTextArea} cols={4} rows={3} maxLength={800}
                />
                          
            </Form>
            
        </>
    );                                                                
};

export default GeneralSolicitudVacantes;
